'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _languageHandler = require('../../../languageHandler');

var _Modal = require('../../../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyBackupPanel = function (_React$PureComponent) {
    (0, _inherits3.default)(KeyBackupPanel, _React$PureComponent);

    function KeyBackupPanel(props) {
        (0, _classCallCheck3.default)(this, KeyBackupPanel);

        var _this = (0, _possibleConstructorReturn3.default)(this, (KeyBackupPanel.__proto__ || (0, _getPrototypeOf2.default)(KeyBackupPanel)).call(this, props));

        _this._startNewBackup = _this._startNewBackup.bind(_this);
        _this._deleteBackup = _this._deleteBackup.bind(_this);
        _this._onKeyBackupSessionsRemaining = _this._onKeyBackupSessionsRemaining.bind(_this);
        _this._onKeyBackupStatus = _this._onKeyBackupStatus.bind(_this);
        _this._restoreBackup = _this._restoreBackup.bind(_this);

        _this._unmounted = false;
        _this.state = {
            loading: true,
            error: null,
            backupInfo: null,
            sessionsRemaining: 0
        };
        return _this;
    }

    (0, _createClass3.default)(KeyBackupPanel, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this._checkKeyBackupStatus();

            _MatrixClientPeg2.default.get().on('crypto.keyBackupStatus', this._onKeyBackupStatus);
            _MatrixClientPeg2.default.get().on('crypto.keyBackupSessionsRemaining', this._onKeyBackupSessionsRemaining);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._unmounted = true;

            if (_MatrixClientPeg2.default.get()) {
                _MatrixClientPeg2.default.get().removeListener('crypto.keyBackupStatus', this._onKeyBackupStatus);
                _MatrixClientPeg2.default.get().removeListener('crypto.keyBackupSessionsRemaining', this._onKeyBackupSessionsRemaining);
            }
        }
    }, {
        key: '_onKeyBackupSessionsRemaining',
        value: function _onKeyBackupSessionsRemaining(sessionsRemaining) {
            this.setState({
                sessionsRemaining: sessionsRemaining
            });
        }
    }, {
        key: '_onKeyBackupStatus',
        value: function _onKeyBackupStatus() {
            // This just loads the current backup status rather than forcing
            // a re-check otherwise we risk causing infinite loops
            this._loadBackupStatus();
        }
    }, {
        key: '_checkKeyBackupStatus',
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var _ref2, backupInfo, trustInfo;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return (0, _bluebird.resolve)(_MatrixClientPeg2.default.get().checkKeyBackup());

                            case 3:
                                _ref2 = _context.sent;
                                backupInfo = _ref2.backupInfo;
                                trustInfo = _ref2.trustInfo;

                                this.setState({
                                    backupInfo: backupInfo,
                                    backupSigStatus: trustInfo,
                                    error: null,
                                    loading: false
                                });
                                _context.next = 15;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](0);

                                console.log("Unable to fetch check backup status", _context.t0);

                                if (!this._unmounted) {
                                    _context.next = 14;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 14:
                                this.setState({
                                    error: _context.t0,
                                    backupInfo: null,
                                    backupSigStatus: null,
                                    loading: false
                                });

                            case 15:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 9]]);
            }));

            function _checkKeyBackupStatus() {
                return _ref.apply(this, arguments);
            }

            return _checkKeyBackupStatus;
        }()
    }, {
        key: '_loadBackupStatus',
        value: function () {
            var _ref3 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var backupInfo, backupSigStatus;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.setState({ loading: true });
                                _context2.prev = 1;
                                _context2.next = 4;
                                return (0, _bluebird.resolve)(_MatrixClientPeg2.default.get().getKeyBackupVersion());

                            case 4:
                                backupInfo = _context2.sent;
                                _context2.next = 7;
                                return (0, _bluebird.resolve)(_MatrixClientPeg2.default.get().isKeyBackupTrusted(backupInfo));

                            case 7:
                                backupSigStatus = _context2.sent;

                                if (!this._unmounted) {
                                    _context2.next = 10;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 10:
                                this.setState({
                                    error: null,
                                    backupInfo: backupInfo,
                                    backupSigStatus: backupSigStatus,
                                    loading: false
                                });
                                _context2.next = 19;
                                break;

                            case 13:
                                _context2.prev = 13;
                                _context2.t0 = _context2['catch'](1);

                                console.log("Unable to fetch key backup status", _context2.t0);

                                if (!this._unmounted) {
                                    _context2.next = 18;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 18:
                                this.setState({
                                    error: _context2.t0,
                                    backupInfo: null,
                                    backupSigStatus: null,
                                    loading: false
                                });

                            case 19:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[1, 13]]);
            }));

            function _loadBackupStatus() {
                return _ref3.apply(this, arguments);
            }

            return _loadBackupStatus;
        }()
    }, {
        key: '_startNewBackup',
        value: function _startNewBackup() {
            var _this2 = this;

            _Modal2.default.createTrackedDialogAsync('Key Backup', 'Key Backup', import('../../../async-components/views/dialogs/keybackup/CreateKeyBackupDialog'), {
                onFinished: function onFinished() {
                    _this2._loadBackupStatus();
                }
            });
        }
    }, {
        key: '_deleteBackup',
        value: function _deleteBackup() {
            var _this3 = this;

            var QuestionDialog = _index2.default.getComponent('dialogs.QuestionDialog');
            _Modal2.default.createTrackedDialog('Delete Backup', '', QuestionDialog, {
                title: (0, _languageHandler._t)('Delete Backup'),
                description: (0, _languageHandler._t)("Are you sure? You will lose your encrypted messages if your " + "keys are not backed up properly."),
                button: (0, _languageHandler._t)('Delete Backup'),
                danger: true,
                onFinished: function onFinished(proceed) {
                    if (!proceed) return;
                    _this3.setState({ loading: true });
                    _MatrixClientPeg2.default.get().deleteKeyBackupVersion(_this3.state.backupInfo.version).then(function () {
                        _this3._loadBackupStatus();
                    });
                }
            });
        }
    }, {
        key: '_restoreBackup',
        value: function _restoreBackup() {
            var RestoreKeyBackupDialog = _index2.default.getComponent('dialogs.keybackup.RestoreKeyBackupDialog');
            _Modal2.default.createTrackedDialog('Restore Backup', '', RestoreKeyBackupDialog, {});
        }
    }, {
        key: 'render',
        value: function render() {
            var Spinner = _index2.default.getComponent("elements.Spinner");
            var AccessibleButton = _index2.default.getComponent("elements.AccessibleButton");
            var encryptedMessageAreEncrypted = (0, _languageHandler._t)("Encrypted messages are secured with end-to-end encryption. " + "Only you and the recipient(s) have the keys to read these messages.");

            if (this.state.error) {
                return _react2.default.createElement(
                    'div',
                    { className: 'error' },
                    (0, _languageHandler._t)("Unable to load key backup status")
                );
            } else if (this.state.loading) {
                return _react2.default.createElement(Spinner, null);
            } else if (this.state.backupInfo) {
                var EmojiText = _index2.default.getComponent('elements.EmojiText');
                var clientBackupStatus = void 0;
                var restoreButtonCaption = (0, _languageHandler._t)("Restore from Backup");

                if (_MatrixClientPeg2.default.get().getKeyBackupEnabled()) {
                    clientBackupStatus = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            encryptedMessageAreEncrypted
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            (0, _languageHandler._t)("This device is backing up your keys. "),
                            _react2.default.createElement(
                                EmojiText,
                                null,
                                '\u2705'
                            )
                        )
                    );
                } else {
                    clientBackupStatus = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            encryptedMessageAreEncrypted
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            (0, _languageHandler._t)("This device is <b>not backing up your keys</b>.", {}, { b: function b(sub) {
                                    return _react2.default.createElement(
                                        'b',
                                        null,
                                        sub
                                    );
                                } })
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            (0, _languageHandler._t)("Back up your keys before signing out to avoid losing them.")
                        )
                    );
                    restoreButtonCaption = (0, _languageHandler._t)("Use key backup");
                }

                var uploadStatus = void 0;
                var sessionsRemaining = this.state.sessionsRemaining;

                if (!_MatrixClientPeg2.default.get().getKeyBackupEnabled()) {
                    // No upload status to show when backup disabled.
                    uploadStatus = "";
                } else if (sessionsRemaining > 0) {
                    uploadStatus = _react2.default.createElement(
                        'div',
                        null,
                        (0, _languageHandler._t)("Backing up %(sessionsRemaining)s keys...", { sessionsRemaining: sessionsRemaining }),
                        ' ',
                        _react2.default.createElement('br', null)
                    );
                } else {
                    uploadStatus = _react2.default.createElement(
                        'div',
                        null,
                        (0, _languageHandler._t)("All keys backed up"),
                        ' ',
                        _react2.default.createElement('br', null)
                    );
                }

                var backupSigStatuses = this.state.backupSigStatus.sigs.map(function (sig, i) {
                    var deviceName = sig.device ? sig.device.getDisplayName() || sig.device.deviceId : null;
                    var validity = function validity(sub) {
                        return _react2.default.createElement(
                            'span',
                            { className: sig.valid ? 'mx_KeyBackupPanel_sigValid' : 'mx_KeyBackupPanel_sigInvalid' },
                            sub
                        );
                    };
                    var verify = function verify(sub) {
                        return _react2.default.createElement(
                            'span',
                            { className: sig.device && sig.device.isVerified() ? 'mx_KeyBackupPanel_deviceVerified' : 'mx_KeyBackupPanel_deviceNotVerified' },
                            sub
                        );
                    };
                    var device = function device(sub) {
                        return _react2.default.createElement(
                            'span',
                            { className: 'mx_KeyBackupPanel_deviceName' },
                            deviceName
                        );
                    };
                    var sigStatus = void 0;
                    if (!sig.device) {
                        sigStatus = (0, _languageHandler._t)("Backup has a signature from <verify>unknown</verify> device with ID %(deviceId)s.", { deviceId: sig.deviceId }, { verify: verify });
                    } else if (sig.device.getFingerprint() === _MatrixClientPeg2.default.get().getDeviceEd25519Key()) {
                        sigStatus = (0, _languageHandler._t)("Backup has a <validity>valid</validity> signature from this device", {}, { validity: validity });
                    } else if (sig.valid && sig.device.isVerified()) {
                        sigStatus = (0, _languageHandler._t)("Backup has a <validity>valid</validity> signature from " + "<verify>verified</verify> device <device></device>", {}, { validity: validity, verify: verify, device: device });
                    } else if (sig.valid && !sig.device.isVerified()) {
                        sigStatus = (0, _languageHandler._t)("Backup has a <validity>valid</validity> signature from " + "<verify>unverified</verify> device <device></device>", {}, { validity: validity, verify: verify, device: device });
                    } else if (!sig.valid && sig.device.isVerified()) {
                        sigStatus = (0, _languageHandler._t)("Backup has an <validity>invalid</validity> signature from " + "<verify>verified</verify> device <device></device>", {}, { validity: validity, verify: verify, device: device });
                    } else if (!sig.valid && !sig.device.isVerified()) {
                        sigStatus = (0, _languageHandler._t)("Backup has an <validity>invalid</validity> signature from " + "<verify>unverified</verify> device <device></device>", {}, { validity: validity, verify: verify, device: device });
                    }

                    return _react2.default.createElement(
                        'div',
                        { key: i },
                        sigStatus
                    );
                });
                if (this.state.backupSigStatus.sigs.length === 0) {
                    backupSigStatuses = (0, _languageHandler._t)("Backup is not signed by any of your devices");
                }

                var trustedLocally = void 0;
                if (this.state.backupSigStatus.trusted_locally) {
                    trustedLocally = (0, _languageHandler._t)("This backup is trusted because it has been restored on this device");
                }

                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        null,
                        clientBackupStatus
                    ),
                    _react2.default.createElement(
                        'details',
                        null,
                        _react2.default.createElement(
                            'summary',
                            null,
                            (0, _languageHandler._t)("Advanced")
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            (0, _languageHandler._t)("Backup version: "),
                            this.state.backupInfo.version
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            (0, _languageHandler._t)("Algorithm: "),
                            this.state.backupInfo.algorithm
                        ),
                        uploadStatus,
                        _react2.default.createElement(
                            'div',
                            null,
                            backupSigStatuses
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            trustedLocally
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            AccessibleButton,
                            { kind: 'primary', onClick: this._restoreBackup },
                            restoreButtonCaption
                        ),
                        '\xA0\xA0\xA0',
                        _react2.default.createElement(
                            AccessibleButton,
                            { kind: 'danger', onClick: this._deleteBackup },
                            (0, _languageHandler._t)("Delete Backup")
                        )
                    )
                );
            } else {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            (0, _languageHandler._t)("Your keys are <b>not being backed up from this device</b>.", {}, { b: function b(sub) {
                                    return _react2.default.createElement(
                                        'b',
                                        null,
                                        sub
                                    );
                                } })
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            encryptedMessageAreEncrypted
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            (0, _languageHandler._t)("Back up your keys before signing out to avoid losing them.")
                        )
                    ),
                    _react2.default.createElement(
                        AccessibleButton,
                        { kind: 'primary', onClick: this._startNewBackup },
                        (0, _languageHandler._t)("Start using Key Backup")
                    )
                );
            }
        }
    }]);
    return KeyBackupPanel;
}(_react2.default.PureComponent); /*
                                  Copyright 2018 New Vector Ltd
                                  
                                  Licensed under the Apache License, Version 2.0 (the "License");
                                  you may not use this file except in compliance with the License.
                                  You may obtain a copy of the License at
                                  
                                      http://www.apache.org/licenses/LICENSE-2.0
                                  
                                  Unless required by applicable law or agreed to in writing, software
                                  distributed under the License is distributed on an "AS IS" BASIS,
                                  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                  See the License for the specific language governing permissions and
                                  limitations under the License.
                                  */

exports.default = KeyBackupPanel;
module.exports = exports['default'];
//# sourceMappingURL=KeyBackupPanel.js.map